/**
 * PasswordInput - 비밀번호 입력 컴포넌트
 *
 * Input 컴포넌트를 감싸며, 눈 아이콘 토글로 비밀번호 표시/숨김을 전환한다.
 */
'use client';

import React, { useState, forwardRef } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import Input, { type InputProps } from './Input';
import styles from './PasswordInput.module.css';

export type PasswordInputProps = Omit<InputProps, 'type' | 'rightIcon'>;

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>((props, ref) => {
  const [visible, setVisible] = useState(false);

  return (
    <Input
      ref={ref}
      {...props}
      type={visible ? 'text' : 'password'}
      rightIcon={
        <button
          type="button"
          className={styles.toggleButton}
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? '비밀번호 숨기기' : '비밀번호 표시'}
          tabIndex={-1}
        >
          {visible ? <EyeOff size={20} /> : <Eye size={20} />}
        </button>
      }
    />
  );
});

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
